import * as t from  './actionTypes';
import * as api from './api';

export function loadSportsletters() {

    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.getSportsletters((success, sports, error) => {
            if (success) {
                dispatch({ type: t.SPORTS_LOAD_SUCCESS, sports: sports });
                dispatch({ type: t.UNSET_BUSY });
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
            }
        });
    }
}

export function createNewSports(data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.createNewSports(data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.SPORTS_CREATE_SUCCESS, sports: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function editSports(id, data, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.editSports(id, data, function(success, data, error) {
            if (success) {
                dispatch({ type: t.SPORTS_EDIT_SUCCESS, id: id, sports: data });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}

export function deleteSports(id, successCB, errorCB) {
    return (dispatch) => {
        dispatch({ type: t.SET_BUSY });

        api.deleteSports(id, function(success, error) {
            if (success) {
                dispatch({ type: t.SPORTS_DELETE_SUCCESS, id: id });
                dispatch({ type: t.UNSET_BUSY });
                successCB();
            } else if (error) {
                dispatch({ type: t.UNSET_BUSY });
                errorCB(error);
            }
        })
    }
}
